import { render, staticRenderFns } from "./DocumentsTable.vue?vue&type=template&id=3eff1f18"
import script from "./DocumentsTable.vue?vue&type=script&lang=js"
export * from "./DocumentsTable.vue?vue&type=script&lang=js"
import style0 from "./DocumentsTable.vue?vue&type=style&index=0&id=3eff1f18&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports